import $ from "jquery";
import "magnific-popup";

export default function openModal() {
  $(".js-open-modal").magnificPopup({
    type: "inline",
    midClick: true,
    callbacks: {
      open: function () {
        $("body").addClass("mfp-active");
      },
      close: function () {
        $("body").removeClass("mfp-active");
      },
      change: function () {
        const objects = this.content
          .get(0)
          .querySelectorAll(".floorplan-modal-svg-wrap .floorplan-object");

        objects.forEach((object) => {
          const objectID = object.getAttribute("href");

          const tableRow = document.querySelector(
            `.js-objects-floorplan-list-item[data-id='${objectID}']`
          );

          if (tableRow) {
            const status = tableRow.dataset.status;
            object.dataset.status = status;
          }
        });
      },
    },
  });
}
